import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { ReactComponent as LogoBlue } from '../../images/header/logo_blue.svg'
import { ReactComponent as LogoColored } from '../../images/header/logo_colored.svg'
import { ReactComponent as LogoWhite } from '../../images/header/logo_white.svg'
import React from 'react'

const TagLogo = ( { logoColor } ) => (
  <Link
    data-testid="logo-anchor"
    to="/"
  >
    { logoColor === 'blue' && <LogoBlue /> }
    { logoColor === 'colored' && <LogoColored /> }
    { logoColor === 'white' && <LogoWhite /> }
  </Link>
)

TagLogo.propTypes = {
  'logoColor': PropTypes.string
}

TagLogo.defaultProps = {
  'logoColor': 'blue'
}

export default TagLogo
